<template>
  <div id="ExhibitionMobile">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner"></div>

      <div class="main2-content">
        <div class="layout-flex-title">
          <div class="title-btn active" @click="handleBtnChange('store')">
            ID.STORE
          </div>
          <div class="title-btn" @click="handleBtnChange('storep')">
            ID.3潮趣展
          </div>
        </div>
      </div>

      <!-- 列表车型 -->
      <div class="main2-content" style="padding-top: 37px">
        <div
          class="layout-flex"
          v-for="(item, index) in workspace5"
          :key="index"
        >
          <div class="layout-flex-2">
            <el-carousel
              indicator-position="none"
              arrow="always"
              :autoplay="false"
              style="width: 100%"
              height="209px"
              :initial-index="dialogIndex"
            >
              <el-carousel-item
                v-for="(item2, index2) in item.imgurlMobile"
                :key="'z' + index2"
              >
                <div @click="handleVideo(index, index2)">
                  <img :src="item2" style="width: 100%" />
                  <img class="videoPlay" src="./components/play.png" />
                </div>
              </el-carousel-item>
              <el-carousel-item
                v-for="(item2, index2) in item.imgurlMobile2"
                :key="index2"
              >
                <img
                  @click="handleImg2(index, index2)"
                  :src="item2"
                  style="width: 100%"
                />
              </el-carousel-item>
            </el-carousel>
          </div>

          <div class="layout-flex-1">
            <div class="detail-icon">
              <img class="image" :src="item.iconurl" />
            </div>
            <div class="detail-title">{{ item.title }}</div>
            <div class="detail-content">{{ item.content }}</div>
            <div style="text-align: right" v-if="item.url">
              <div class="detail-btn" @click="handleDetail(item.url)"></div>
            </div>
          </div>
        </div>
        <div>
          <img class="image" src="https://www.csvw.com/u/cms/www/202110/15203537y9B4.png"/>
        </div>
      </div>

      <!-- 现场花絮 -->
      <div
        class="main2-content"
        style="padding-top: 37px; padding-bottom: 37px"
      >
        <div class="title">
          <div class="titlebg"></div>
          <div class="t1">探秘ID.Store</div>
        </div>
        <div>
          <el-carousel
            type="card"
            indicator-position="none"
            arrow="always"
            :autoplay="false"
            style="width: 100%"
            height="107px"
            :initial-index="dialogIndex"
          >
            <el-carousel-item
              v-for="(item, index) in workspace6Item"
              :key="index"
            >
              <img @click="handleImg(index)" :src="item" style="width: 100%" />
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>

    <!-- 弹框图片 -->
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <el-carousel
        indicator-position="none"
        arrow="always"
        :autoplay="false"
        style="width: 100%"
        height="215px"
        :initial-index="dialogIndex"
      >
        <el-carousel-item v-for="(item, index) in list" :key="index">
          <img :src="item" style="width: 100%" />
        </el-carousel-item>
      </el-carousel>
    </el-dialog>
    <!-- 弹框视频播放 -->
    <el-dialog :visible.sync="dialogVisible2" v-if="dialogVisible2">
      <contentVideo2 :url="dialogVideo"></contentVideo2>
    </el-dialog>
  </div>
</template>

<script>
import contentVideo from "./components/contentVideoMobile.vue";
import contentVideo2 from "./components/contentVideoMobile2.vue";
import config from "./config";

export default {
  components: {
    contentVideo,
    contentVideo2,
  },
  data() {
    return {
      ...config,
      index6: "workspace60bigMobile",
      list: [],
      // 图片
      dialogVisible: false,
      // 视频
      dialogVisible2: false,
      dialogIndex: 0,
      dialogImg: "",
      dialogVideo: "",
    };
  },
  computed: {
    workspace6Item() {
      return this[`${this.index6}`];
    },
  },
  mounted() {},
  methods: {
    // 详情
    handleDetail(url) {
      window.open(url, "_blank");
    },
    // 列表-图片
    handleImg2(index, index2) {
      this.dialogVisible = true;
      this.list = this.workspace5[index]["imgurlMobile2"];
      this.dialogIndex = index2;
    },
    // 列表-视频
    handleVideo(index, index2) {
      this.dialogVisible2 = true;
      this.dialogVideo = this.workspace5[index]["videourl"][index2];
    },
    // 花絮-图片
    handleImg(index) {
      this.dialogVisible = true;
      this.list = this.workspace60bigMobile;
      this.dialogIndex = index;
    },
    // 切换车子
    handleBtnChange(key) {
      this.$emit("changeTab", key);
    },
  },
};
</script>
<style lang="less" scoped>
@import "./mobile.less";
</style>
